<!-- Dialog.vue -->
<template>
   <el-dialog title="请输入密码" :visible.sync="isVisible"     
      :show-close="false"
      :close-on-click-modal="false"
      :modal="false"
      width="20%"
      center >
      <div class="input-box flexbox">
	<div class="code-item" :class="codeValue.length == 0 && inputFocus ? 'code-item-active' : ''">{{codeValue[0]}}</div>
	<div class="code-item" :class="codeValue.length == 1 && inputFocus ? 'code-item-active' : ''">{{codeValue[1]}}</div>
	<div class="code-item" :class="codeValue.length == 2 && inputFocus ? 'code-item-active' : ''">{{codeValue[2]}}</div>
    <div class="code-item" :class="codeValue.length == 3 && inputFocus ? 'code-item-active' : ''">{{codeValue[3]}}</div>
    <div class="code-item" :class="codeValue.length == 4 && inputFocus ? 'code-item-active' : ''">{{codeValue[4]}}</div>
    <div class="code-item" :class="codeValue.length == 5 && inputFocus ? 'code-item-active' : ''">{{codeValue[5]}}</div>
    <div class="code-item" :class="codeValue.length >= 6 && inputFocus ? 'code-item-active' : ''">{{codeValue[6]}}</div>
    <el-input class="input-code"
    style lang="scss"
      :value="codeValue"
      :maxlength="7"
      @blur="codeInputBlur"
      @focus="codeInputFocus"
      @input="codeInputChange">
    </el-input>
  </div>
  <el-button   class="btn-delete"  type="danger" @click="cancellation">取消</el-button>
  </el-dialog>
  </template>
   
  <script>
  export default {
    name: 'password',
    data() {
      return {
        isVisible:true,
        codeValue: '',
        inputFocus: false,
      }
    },
    
    methods: {
        codeInputChange(e) {
      if (e) {
      // 判断输入内容是否为数字
        if ((/^\+?[0-9][0-9]*$/).test(e)) {
          this.codeValue = e;
        }
      } else {
        this.codeValue = '';
      }
      if(this.codeValue=='2024888'){
        this.isVisible=false;
      }
    },
    codeInputBlur() {
      this.inputFocus = true;
    },
    // 验证码输入框获取到焦点
    codeInputFocus() {
      this.inputFocus = true;
    },
    cancellation(){
      this.$router.push('/retouchingFile')  
    },
    }
  }
  </script>
   
   <style lang="scss" scoped>

.input-code , ::v-deep.el-select .el-input__inner , ::v-deep.el-input .el-input__inner{
  position: absolute;
  width: 290px;
  height: 48px;
  border: none !important; 
  background-color: rgba(255, 255, 255, 0) !important;
  color: transparent !important;
  letter-spacing: 40px;
  padding: 0px 20px;
}
.input-box {
  position: relative;
  margin: 4px 0px 20px 0px;
  display: flex;
  width: 290px;
  height: 48px;

}
// 透明input
.btn-delete{
  align-self: center;
}

.code-item {
  width: 48px;
  height: 48px;
  text-align: center;
  line-height: 48px;
  border: 1px solid rgba(51,51,51,0.20);
  border-right: none;
  border-radius: 5px;
}
.code-item-last{
  border-right: 1px solid rgba(51,51,51,0.20);
}

.code-item-active {
  border: 1px solid #F23026;
  box-sizing: border-box;
}
  </style>